import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

require('./Footer.scss')

interface FooterProps {
    minimal?: boolean
    location: string
}

const Footer = ({ minimal, location }: FooterProps) => {
    const { t } = useTranslation()
    return (
        <div className={classNames(`Footer ${location}`, { minimal })}>
            <div className="footerContent">
                <div className="copyContainer">
                    <span className="copyright">{t('footer.copyright')}</span>
                </div>
                <div className="legal">
                    <Link to="/termsofuse">{t('footer.Terms and Conditions')}</Link>
                    <Link to="/privacypolicy">{t('footer.Privacy Policy')}</Link>
                </div>
            </div>
        </div>
    )
}

Footer.defaultProps = {
    minimal: false,
}

export default Footer
